<template>
    <div class="docs-list" id="section-10" style="display: none">
        <h1>Private Protocol</h1>

        <hr />

        <pre><code>Since iBeacon is an open protocol, everyone can make a beacon as same as yours to destroy the system you build. To solve this problem, we launched our private protocol.
</code></pre>

        <h3>How it works</h3>

        <p><strong>Poor security reasons of iBeacon：</strong></p>

        <ol>
            <li>Broadcast content is constant (UUID + Major + Minor)</li>
            <li>Everyone can forge the beacon</li>
        </ol>


        <p><strong>To solve this problem, we launched our private protocol：</strong></p>

        <pre><code>Every beacon can set a broadcast key,for example "01Y2GLh1yw3+6Aq0RsnOQ8xNvXTnDUTTLE937Yedd/DnkHESUpvQ7YvLucs9YfwGR5R/jwW8Rqp9XtGbmwbKXzXQ==".
Broadcast content will be encrypted by the key.
When using our SDK,you can set the broadcast key then the SDK can decrypt the broadcast content.

Through such a symmetric encryption, we can achieve:
1. Encryption: prevent others scrap beacon.
2. Validation: prevent others forge beacon.
</code></pre>

        <h3>How to use</h3>

        <h4>I. Apply KEY</h4>

        <pre><code>Since the number of the key is limited, if you really need the key please send email to us to apply.

Email：service@sensoro.com.
</code></pre>

        <h4>II. Get KEY in SENSORO Cloud</h4>

        <p style="text-align:center">
            <img src="/static/image/developer/private/1.png" height="514" width="700" alt="" />
        </p>

        <h4>III. Set KEY in your beacon</h4>

        <ol>
            <li>
                <p>Add Key in your Configuration Tool.
                "Menu" -> "Key" -> "Set local password" -> "scan QRcode to add the key"
                </p>

                <p style="text-align:center">
                    <img src="/static/image/developer/private/2.png" height="480" width="270" alt="" />
                    <img src="/static/image/developer/private/4.png" height="480" width="270" alt="" />
                </p>
            </li>
            <li>
                <p>Choose one 3.0 beacon and add the key</p>

                <p  style="text-align:center">
                    <img src="/static/image/developer/private/3.png" height="480" width="270" alt="" />
                    <img src="/static/image/developer/private/4.png" height="480" width="270" alt="" />
                </p>
            </li>
        </ol>

        <h4>IV. Add KEY in other tools</h4>

        <pre><code>Since the beacon has the key, so we need to set the key in the ohter tools to decrypt the broadcast content.
</code></pre>

        <p><strong>All Tools:</strong></p>

        <ol>
            <li>Configuration Tool</li>
            <li>Inspection Tool</li>
            <li>Deployment Tool</li>
        </ol>

    </div>
</template>

<script>
    export default {
        name: "private"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/docs/privateEN.vue